import { OPENAI_BILLING_URL } from "../constants/openAI";

interface Props {
    message: string;
    billingUrl?: string;
}

export default function OpenAIQuotaToastContent({ message, billingUrl }: Props) {
    return (
        <div>
            <div>{message}</div>
            <a
                href={billingUrl || OPENAI_BILLING_URL}
                target="_blank"
                rel="noreferrer"
                style={{ color: 'inherit', fontWeight: 600, textDecoration: 'underline' }}
            >
                Otwórz rozliczenia OpenAI
            </a>
        </div>
    );
}
